import React, { useEffect, } from 'react';
import 'node-waves';
import { JqueryClassFaker } from "../../components/JqueryClassFaker";

export default function useWavesEffect(domRef, active = true) {
	useEffect(() => {
		if(active) {
			Waves.attach(domRef.current);
			Waves.init();
		}
		else {
			Waves.remove;
		}
	}, [domRef, active]);

	return new JqueryClassFaker(active ? 'waves-effect waves-light' : undefined);
};